import { useState, useEffect } from 'react';

const LoadTime = () => {
  const [loadTime, setLoadTime] = useState({});
  const getTiming = () => {
    setTimeout(() => {
      const t = window.performance.timing;
      // ms
      const performanceInfo = {
        // 网页重定向的耗时
        Redirect: t.redirectEnd - t.redirectStart,
        //  检查本地缓存的耗时
        AppCache: t.domainLookupStart - t.fetchStart,
        // DNS查询的耗时
        DNS: t.domainLookupEnd - t.domainLookupStart,
        // TCP链接的耗时
        TCP: t.connectEnd - t.connectStart,
        // Waiting(TTFB) 从客户端发起请求到接收响应的时间
        TTFB: t.responseStart - t.requestStart,
        // 下载服务端返回数据的时间
        ContentDownload: t.responseEnd - t.responseStart,
        // http请求总耗时
        HTTPTotalTime: t.responseEnd - t.requestStart,
        // 首包时间
        FirstTime: t.responseStart - t.domainLookupStart,
        // 白屏时间
        WhiteScreenTime: t.responseEnd - t.fetchStart,
        // 首次可交互时间 Time to Interactive
        TTI: t.domInteractive - t.fetchStart,
        // DOM 解析耗时
        DOMParsing: t.domInteractive - t.responseEnd,
        // DOM 加载完成的时间
        DOMContentLoaded: t.domInteractive - t.navigationStart,

        // 页面load的总耗时
        Loaded: t.loadEventEnd - t.navigationStart,
      };
      setLoadTime(performanceInfo);
    }, 0);
  };
  useEffect(() => {
    window.addEventListener('load', getTiming);
    return () => {
      window.removeEventListener('load', getTiming);
    };
  }, []);
  return [loadTime];
};

export default LoadTime;
